import React from 'react'
import { Typography } from '@chegg-ui/typography'
import Image from 'next/image'
import { publicAssetUrl } from '@chegg-wt/core/utils/url'
import { spacing } from '@chegg-ui/theme'
import { navigated } from '@chegg-wt/core/state/app/actions'
import { useRoutesContext } from '@chegg-wt/core/components/RoutesContext'
import { useDispatch } from 'react-redux'
import {
  ArrowIcon,
  BannerHeading,
  BetaReleaseContainer,
  BetaReleaseText,
  EntryBanner,
  GetStartedButton,
  ImageContainer,
  TextSection,
} from './styled'

const PENCIL_ICON_WIDTH = 44
const PENCIL_ICON_HEIGHT = 44

export const EntryPointBanner = () => {
  const dispatch = useDispatch()
  const { toProofReader } = useRoutesContext()

  const handleOnclick = () => {
    dispatch(navigated(toProofReader()))
  }

  return (
    <EntryBanner>
      <ImageContainer>
        <Image
          src={publicAssetUrl('IconPencil.svg')}
          alt="Keep Writing"
          width={PENCIL_ICON_WIDTH}
          height={PENCIL_ICON_HEIGHT}
        />
      </ImageContainer>

      <TextSection>
        <BetaReleaseContainer>
          <BetaReleaseText>Beta release</BetaReleaseText>
        </BetaReleaseContainer>
        <BannerHeading>Polish your writing</BannerHeading>

        <Typography variant="subtitle" variantType="normal">
          Instant proofreading and paraphrasing to help you find the right words
        </Typography>
      </TextSection>

      <GetStartedButton width={spacing.px144} onClick={handleOnclick}>
        Get Started <ArrowIcon />
      </GetStartedButton>
    </EntryBanner>
  )
}
